import { render } from "./SectionPunchlines.vue?vue&type=template&id=153ea646"
import script from "./SectionPunchlines.vue?vue&type=script&lang=js"
export * from "./SectionPunchlines.vue?vue&type=script&lang=js"

import "./SectionPunchlines.vue?vue&type=style&index=0&id=153ea646&lang=scss"

import exportComponent from "/Users/lucas/Web/_loco/theadccawards/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__